import { DIM_ROUTE, ACTIVE_ROUTE, THIN_ROUTE, HOVER_ROUTE, NON_STOP, ONE_STOP, TWO_STOPS } from "./defines";

export const getRouteOptions = () => {
    return [NON_STOP, ONE_STOP, TWO_STOPS];
}

export const getDayName = (day) => {
    const weekday = getDayNames();
    const d = day === undefined ? new Date() : day;

    return weekday[d.getDay()];
}

export const getDayNames = () => (["sun", "mon", "tue", "wed", "thu", "fri", "sat"]);

export const getWeekOptions = () => {
    const today = new Date();
    const days = getDayNames();
    const part1 = days.slice(today.getDay(), 7);
    const part2 = days.slice(0, today.getDay());
    const weekDays = part1.concat(part2);
    const result = [];
    for (const i in weekDays) {
        const t = new Date();
        if (i > 0) {
            t.setTime(t.getTime() + (24 * 3600 * 1000 * i));
        }

        result.push(weekDays[i] + '-' + t.getDate() + '/' + (t.getMonth() + 1));
    }

    return result;
}

export const getDaysFromToday = () => {
    const today = new Date();
    const days = getDayNames();
    const part1 = days.slice(today.getDay(), 7);
    const part2 = days.slice(0, today.getDay());
    const weekDays = part1.concat(part2);
    const result = [];
    for (const i in weekDays) {
        result.push(weekDays[i]);
    }

    return result;
}

export const getDateMonth = (day, isSchedule = false) => {
    const today = new Date();
    const days = getDayNames();
    const part1 = days.slice(today.getDay(), 7);
    const part2 = days.slice(0, today.getDay());
    const weekDays = part1.concat(part2);

    for (const i in weekDays) {
        const t = new Date();
        if (i > 0) {
            t.setTime(t.getTime() + (24 * 3600 * 1000 * i));
        }

        if (weekDays[i] === day) {
            const dd = String(t.getDate()).padStart(2, '0');
            const mm = String(t.getMonth() + 1).padStart(2, '0'); //January is 0!
            const yyyy = t.getFullYear();

            return isSchedule ? yyyy + '-' + mm + '-' + dd : mm + '-' + dd + '-' + yyyy;
        }
    }

    return '';
}

export const getSegmentOption = (state) => {
    if (state === HOVER_ROUTE) {
        return {
            geodesic: true,
            strokeWeight: 2.4,
            strokeOpacity: 1,
            strokeColor: '#f2a41c'
        };
    }

    return {
        geodesic: true,
        strokeWeight: 1.4,
        strokeOpacity: 0.3,
        strokeColor: '#005f6e'
    };
}

export const getLineOption = (airlineCode, state) => {
    let strokeOpacity = 1, strokeWeight = 2.4;
    if (state === DIM_ROUTE) {
        strokeOpacity = 0.3;
    } else if (state === ACTIVE_ROUTE) {
        strokeWeight = 4.2;
    } else if (state === THIN_ROUTE) {
        strokeWeight = 1.4;
    } else if (airlineCode === null && state === HOVER_ROUTE) {
        return {
            geodesic: true,
            strokeColor: '#005f6e',
            strokeOpacity: 0,
            icons: [
                {
                    icon: {
                        path: 'M 0,-1 0,1',
                        strokeOpacity: 0.5,
                        strokeWeight: 1.4,
                        scale: 2
                    },
                    offset: '0',
                    repeat: '10px'
                },
            ]
        };
    }

    const va = {
        geodesic: true,
        strokeWeight,
        strokeOpacity,
        strokeColor: '#005f6e'
    };

    const vc = {
        geodesic: true,
        strokeWeight,
        strokeOpacity,
        strokeColor: '#0057b3'
    }

    const pa = {
        geodesic: true,
        strokeWeight,
        strokeOpacity,
        strokeColor: '#2b3860'
    }

    const lineSymbol = {
        path: 'M 0,-1 0,1',
        strokeOpacity,
        strokeWeight,
        scale: 2
    };

    const codeshare = {
        geodesic: true,
        strokeColor: '#f27b61',
        strokeOpacity: 0,
        icons: [
            {
                icon: lineSymbol,
                offset: '0',
                repeat: '10px'
            },
        ]
    };

    switch (airlineCode) {
        case 'VN':
            return va;
        case 'BL':
            return va;
        // return pa;
        case '0V':
            return vc;
        default:
            return codeshare;
    }
}

export const timeConvert = n => {
    let num = n;
    let hours = (num / 60);
    let rhours = Math.floor(hours);
    let minutes = (hours - rhours) * 60;
    let rminutes = Math.round(minutes);
    return rhours + 'h' + rminutes + 'm';
}

export const getAirlineIcon = (code) => {
    switch (code) {
        case 'VN':
            return './assets/VN.png';
        case 'BL':
            return './assets/BL.png';
        case '0V':
            return './assets/0V.jpg';
        default:
            return '';
    }
}

export const getAirEquipName = (airEquipType, t) => {
    let names = t(airEquipType).split('-');
    return names[0].substring(0, 12);
}

export const getFlightNumber = (segment) => {
    let code = segment.airlineCode;
    if (code === 'BL' || code === '0V') {
        code = 'VN';
    }

    return code + segment.flightNumber;
}

export const getTime = (segments) => {
    if (segments.length > 1) {
        return {
            departureTime: segments[0].departureTime,
            arrivalTime: segments[segments.length - 1].arrivalTime
        };
    }

    return {
        departureTime: segments[0].departureTime,
        arrivalTime: segments[0].arrivalTime
    };
}

export const getStops = (data, t) => {
    if (data.stops > 0) {
        return data.stops + ' ' + t('stop');
    } else {
        return t('non_stop');
    }
}

export const getDistanceFromLatLonInKm = (lat1, lon1, lat2, lon2) => {
    var R = 6371; // Radius of the earth in km
    var dLat = deg2rad(lat2 - lat1);  // deg2rad below
    var dLon = deg2rad(lon2 - lon1);
    var a =
        Math.sin(dLat / 2) * Math.sin(dLat / 2) +
        Math.cos(deg2rad(lat1)) * Math.cos(deg2rad(lat2)) *
        Math.sin(dLon / 2) * Math.sin(dLon / 2)
        ;
    var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    var d = R * c; // Distance in km
    return d;
}

const deg2rad = (deg) => {
    return deg * (Math.PI / 180)
}


export const logErrorLocation = (error) => {
    switch (error.code) {
        case error.PERMISSION_DENIED:
            console.log("User denied the request for Geolocation.");
            break;
        case error.POSITION_UNAVAILABLE:
            console.log("Location information is unavailable.");
            break;
        case error.TIMEOUT:
            console.log("The request to get user location timed out.");
            break;
        case error.UNKNOWN_ERROR:
            console.log("An unknown error occurred.");
            break;
    }
}

export const inIframe = () => {
    try {
        return window.self !== window.top;
    } catch (e) {
        // Trong một số trường hợp hiếm gặp (trình duyệt cũ hoặc chặn truy cập), 
        // việc truy cập window.top có thể gây lỗi, khi đó ta mặc định là true.
        return true;
    }
}

export const getAirportName = (fullString) => {
    // Thay thế phần " (CODE)" ở cuối bằng chuỗi rỗng
    // \s* : Tìm khoảng trắng trước dấu ngoặc (nếu có)
    // \(    : Tìm dấu mở ngoặc
    // [^)]* : Tìm tất cả ký tự bên trong (trừ dấu đóng ngoặc)
    // \)    : Tìm dấu đóng ngoặc
    // $     : Đảm bảo cụm này nằm ở cuối chuỗi
    return fullString.replace(/\s*\([^)]*\)$/, "");
}
